module.exports = "/_next/static/images/oregon-1c707b2760914980e16a93e5ee53a9b5.svg";